import React from "react";
import { Button } from "react-bootstrap";
import { API_BASE } from "APP_ROOT/constants";
import { stringify } from "query-string";
import T from "prop-types";
import { isEmpty } from "lodash";

function DownloadUrl({
  close,
  note,
  salesOrder,
  processingFee,
  chargeType,
  chargeValue
}) {
  const downloadUrl = `${API_BASE}/sales_orders/${salesOrder.get(
    "id"
  )}/download`;

  const params = {
    pro_forma: true
  };

  if (Number(processingFee) > 0) {
    params.processing_fee = processingFee;
  }

  if (!isEmpty(note)) {
    params.note = note;
  }

  if (!isEmpty(chargeType) && !isEmpty(chargeValue)) {
    params.charge_type = chargeType;
    params.charge_value = chargeValue;
  }

  return (
    <Button
      bsStyle="primary"
      onClick={() => {
        window.open(`${downloadUrl}?${stringify(params)}`, "_blank");
        close();
      }}
    >
      Download
    </Button>
  );
}

DownloadUrl.propTypes = {
  close: T.func,
  note: T.string,
  processingFee: T.number,
  salesOrder: T.instanceOf(Map)
};

export default DownloadUrl;



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Actions/DownloadProForma/DownloadUrl.jsx